export const CounterpartiesEndpoint = {
    counterparty: `${process.env.API_BACKEND}/v1/counterparties/counterparty/`,
    contact: `${process.env.API_BACKEND}/v1/counterparties/counterparty/contact`,
} as const
